export const COMMERCIAL_API_TYPE = 'Office,Ruko'
export const COMMERCIAL_NAV_KEY = 'Office'
export const HOUSE_SUB_TYPE_DICT_CODE = 'house_sub_type_Office'

export function isCommercialType(type) {
  if (!type) return false
  return type === COMMERCIAL_API_TYPE || type === 'Office' || type === 'Ruko' || type === 'Commercial'
}

export function getHouseApiType(routeType) {
  return isCommercialType(routeType) ? COMMERCIAL_API_TYPE : routeType
}

export function getFilterConfigType(type) {
  return isCommercialType(type) ? 'Office' : type
}

export function getAreaDictCode(type) {
  if (isCommercialType(type)) return 'yz_area_office_ruko'
  return 'yz_area_' + String(type || '').toLowerCase()
}

export function mapNavActiveKey(key) {
  return key === 'Ruko' ? COMMERCIAL_NAV_KEY : key
}

function normalizeDictItems(list) {
  if (Array.isArray(list) && list.length) return list
  return []
}

export function getCommercialTypeOptions(dictItemsList, translate) {
  const officeTypes = normalizeDictItems(dictItemsList && dictItemsList[HOUSE_SUB_TYPE_DICT_CODE])
  return officeTypes.concat({
    value: 'Ruko',
    text: translate('dict-house_type-ruko'),
    label: translate('dict-house_type-ruko'),
    internationalKey: 'dict-house_type-ruko',
  })
}

export function canFilterOfficeGrade(typeList) {
  return Array.isArray(typeList) && typeList.length > 0 && !typeList.includes('Ruko')
}

export function dictItemLabel(item, translate, hasKey) {
  if (!item) return ''
  if (item.internationalKey && (!hasKey || hasKey(item.internationalKey))) {
    const translated = translate(item.internationalKey)
    if (translated && translated !== item.internationalKey) return translated
  }
  return item.text || item.label || item.value || ''
}
